
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ModelPage from "../pages/model/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/model/:id",
    element: <ModelPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;